import React from "react";
import { useSelector } from "react-redux";
import {  Grid, Label  } from "semantic-ui-react";
import DropDown from "../../../../commonComponents/formComponents/dropDown";
import InputField from "../../../../commonComponents/formComponents/inputField";
import PopUpIcon from "../../../../commonComponents/formComponents/PopUpIcon";
import { TranslateContext } from "../../TranslateContext";
import { postalCodeKey } from "../../../util/NL_fieldPatterns";

const displayError=(value)=>{
  if(!value)
    return null
  return(
    <PopUpIcon style={{"display": "inline"}}
          color="red" icon="exclamation triangle circle"
          popupText={<div className="error">* {value}</div>} />
  )
}
const GoodsLocationForm=({isDMS,displayInfo,fieldPattern,validateError,disableForm,dataSource,onUpdate,saveData,errorInfo:{postalError}})=>{

  const locationTypeList = useSelector((state) => state.DropDownValues.locationTypes);

  const translate = React.useContext(TranslateContext).translate
 

  return (
    <Grid.Row className="theme-textbox">
              
              <label className="label-address">
              {
               displayInfo && <PopUpIcon  icon="info circle"
                  popupText={ <ul><li>{translate("IF_PROCEDURE_CODE_IS_H6_THEN_THIS_SECTION_IS_NOT_ALLOWED_AND_WILL_BE_DISABLED", {ns:["header"]})}</li></ul>}></PopUpIcon>
              }
                {translate("GOODS_LOCATION", {ns:["header"]})}     
              </label>
                         
             
              <Grid.Column className="row" width="4" >
            <Label className="disabled title">
               {displayError(postalError)}
               {translate("POSTAL_CODE", {ns:["default", "header"]})}
              </Label>
            
            <InputField
                  isLabel={false}
                  id="postalCode"
                  name="postalCode"
                  isFooterLabel={true}
                  type="text"
                  clearInput={false}
                  onChange={(value)=>onUpdate({postalCode:value})}
                  {...disableForm}
                  value={dataSource.postalCode}
                  onBlur={(value) =>{
                    if(value?.length>=9 && value?.length<13){
                       value=value.substring(0, 8)+(value.substring(8, 13).padStart(5, 0))
                        onUpdate({postalCode:value})
                    }
                    saveData({postalCode:value || " "})
                    validateError({[`${postalCodeKey}`]:""},{transportation:{goodsLocation:{postalCode:value}}},{[postalCodeKey]:fieldPattern()?.header[postalCodeKey]})}
                  }
                />
              </Grid.Column>
              
             { isDMS && 
             <React.Fragment>
              <Grid.Column className="row" width="4">
              <Label className="disabled title">{translate("HOUSE_NO", {ns:["default", "header"]})}</Label>
              <InputField
                  isLabel={false}
                  isFooterLabel={true}
                  id="houseNo"
                  name="houseNo"
                  type="text"
                  className={"field-bg"}
                  clearInput={false}
                  {...disableForm}
                  onChange={(value)=>onUpdate({houseNo:value})}
                  onBlur={(value) =>saveData({houseNo:dataSource.houseNo || " "})}
                  value={dataSource.houseNo}
                />
              </Grid.Column>
              
              <Grid.Column className="row" width="4">
              <Label className="disabled title">{translate("COUNTRY", {ns:["default", "parties"]})}</Label>
              <InputField
                  isLabel={false}
                  isFooterLabel={true}
                  type="text"
                  id="country"
                  name="country"
                  className={"field-bg"}
                  {...disableForm}
                  onChange={(value)=>onUpdate({country:value})}
                  onBlur={(value) =>saveData({country:dataSource.country || " "})}
                  value={dataSource.country}
            
                />
              </Grid.Column>
              
              <Grid.Column className="row" width="4" >
              <Label className="title">TYPE</Label>
              <DropDown
                id="goodLocationtype"
                data={locationTypeList}
                className="field-bg dropdown100 theme-dropdown"
                clearable
                {...disableForm}
                value={dataSource.type}
        
              onChange={(value)=>onUpdate({type:value})}  
               onBlur={(value) =>saveData({type:dataSource.type})}
            />
             
              </Grid.Column>
              </React.Fragment>

}
             
            
            </Grid.Row>
  );
}

GoodsLocationForm.defaultProps={
    dataSource:{},
    errorInfo:{},
    disableForm:{}
}
export default React.memo(GoodsLocationForm)
